module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "structure-next"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-style"
  }, [_c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("T")]), _vm._v("his book is dedicated to the people that subscribed to my YouTube channel when I first started out. You believed in me when I doubted myself.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761076ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/NGJobHacks_split_003.vue
// module id = 66
// module chunks = 0